import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { useSendAiChatBotMessageMutation } from "../../../app/services/book/aiChatBot"
import useLoadingTip from "../AiChatBot/useLoadingTip"

const AiChatComposer = ({ conversationId, onSent }) => {
  const { t } = useTranslation()
  const [sendMessage, { isLoading }] = useSendAiChatBotMessageMutation()
  const [text, setText] = useState("")
  const [pending, setPending] = useState("")
  const [error, setError] = useState("")
  const tip = useLoadingTip(isLoading)

  const handleSend = async () => {
    const value = text.trim()
    if (!value || isLoading) return
    setPending(value)
    setText("")
    setError("")
    try {
      await sendMessage({ text: value, conversation_id: conversationId }).unwrap()
      await onSent()
    } catch (_error) {
      setText(value)
      setError(t("admin.ai_chat_bot_send_failed", "Could not send. Try again."))
    } finally {
      setPending("")
    }
  }

  return (
    <div className="flex-shrink-0 border-t border-slate-200 bg-white px-3 py-2">
      {pending && (
        <div className="mb-2 text-xs text-slate-500">
          <span className="font-medium text-slate-700">{pending}</span>
          {" · "}
          {tip ? t(tip[0], tip[1]) : t("admin.ai_chat_bot_answering", "AI is answering…")}
        </div>
      )}
      {error && <div className="mb-2 text-xs text-red-600">{error}</div>}
      <div className="flex gap-2">
        <textarea
          value={text}
          onChange={(event) => setText(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter" && !event.shiftKey) {
              event.preventDefault()
              handleSend()
            }
          }}
          rows={1}
          disabled={isLoading}
          placeholder={t("admin.ai_chat_bot_placeholder", 'Ask for a tour, e.g. "2+1, Kemer, 7 nights"')}
          className="flex-1 border border-slate-300 rounded-md px-3 py-2 resize-none text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-slate-50"
        />
        <button
          type="button"
          onClick={handleSend}
          disabled={isLoading || !text.trim()}
          className="px-4 py-2 rounded-md bg-blue-600 text-white text-sm disabled:opacity-50 self-end"
        >
          {t("admin.send", "Send")}
        </button>
      </div>
    </div>
  )
}

export default AiChatComposer
